import { useState } from 'react';
import type { FormEvent } from 'react';
import { supabase } from '@/lib/supabase';

type Status = 'idle' | 'sending' | 'success' | 'error';

export default function useSubscribe(source: string, honeypot: string) {
  const [status, setStatus] = useState<Status>('idle');
  const [formError, setFormError] = useState('');

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);
    const trap = String(data.get(honeypot) || '').trim();
    if (trap) {
      setStatus('success');
      return;
    }
    const email = String(data.get('email') || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setFormError('Please enter a valid email address.');
      setStatus('error');
      return;
    }
    setStatus('sending');
    setFormError('');
    try {
      const { error } = await supabase.from('gs_subscribers').insert({
        email,
        county: String(data.get('county') || '') || null,
        source,
      });
      if (error) throw error;
      setStatus('success');
      form.reset();
    } catch {
      setFormError('Something went wrong. Please try again.');
      setStatus('error');
    }
  };

  return { status, formError, submit };
}